import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_DEPARTMENTS } from "../../../utils/constants";
import departmentService from "../../../services/ticketService/departmentService";
import { DepartmentInterface } from "../../../models/TicketModule/Department";

interface AddDepartmentsContext {
  previousDepartment: DepartmentInterface[];
}

const useAddDepartmen = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    DepartmentInterface,
    Error,
    DepartmentInterface,
    AddDepartmentsContext
  >({
    mutationFn: departmentService.Save,

    onMutate: () => {
      const previousDepartment =
        queryClient.getQueryData<DepartmentInterface[]>([
          CACHE_KEY_DEPARTMENTS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousDepartment };
    },

    onSuccess: (savedDepartment) => {
      queryClient.setQueryData<DepartmentInterface[]>(
        [
          CACHE_KEY_DEPARTMENTS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (departments) =>
          departments ? [savedDepartment, ...departments] : [savedDepartment]
      );
    },

    onError: (error, newDepartment, context) => {
      if (!context) return;

      queryClient.setQueryData<DepartmentInterface[]>(
        [
          CACHE_KEY_DEPARTMENTS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousDepartment
      );
    },
  });
};

export default useAddDepartmen;
